<div class="flex flex-col gap-4">
  <elcia-card [title]="'entity.timesheet-type' | translate">
    <elcia-timesheet-settings-type/>
  </elcia-card>

  <elcia-card [title]="'entity.timesheet-status' | translate">
    <elcia-timesheet-settings-status/>
  </elcia-card>

  <elcia-card [title]="'entity.activity-type' | translate">
    <elcia-timesheet-settings-activity-type/>
  </elcia-card>
</div>
